import { createContext, useContext } from 'react';
import { Path } from '../../utils/redirect-uri';

interface BaseSignedOut {
  accountUuid?: never;
  email?: never;
  error?: never;
  jwt?: never;
  signIn?: never;
  signOut?: never;
  signOutTimedOut?: never;
  source?: never;
  sub?: never;
}

interface Loading extends BaseSignedOut {
  status: 'loading';
}

interface Idle extends Omit<BaseSignedOut, 'signIn'> {
  status: 'idle';
  signIn: (path?: Path, accountId?: string | null, orgId?: string | null) => Promise<void>;
}

interface ErrorValue extends Omit<BaseSignedOut, 'error' | 'signIn'> {
  status: 'error';
  error: Error;
  signIn: (path?: Path) => Promise<void>;
}

interface BaseSignedIn {
  accountUuid: string;
  email: string;
  error?: never;
  jwt: string;
  signIn?: never;
  signOut?: never;
  signOutTimedOut?: never;
  source: 'oidc';
  sub: string;
}

interface SignedIn extends Omit<BaseSignedIn, 'signOut' | 'signOutTimedOut'> {
  status: 'signedIn';
  signOut: (path?: Path) => Promise<void>;
  signOutTimedOut: () => Promise<void>;
}

interface TimedOut extends Omit<BaseSignedIn, 'signIn'> {
  status: 'timedOut';
  signIn: (path?: Path, accountId?: string | null, orgId?: string | null) => Promise<void>;
}

export type AccessTokenContextValue =
  | Loading
  | Idle
  | ErrorValue
  | SignedIn
  | TimedOut;

export const accessTokenContextDefaultValue: AccessTokenContextValue = {
  status: 'loading',
};

export const AccessTokenContext = createContext<AccessTokenContextValue>(
  accessTokenContextDefaultValue,
);
export const useAccessToken = () => useContext(AccessTokenContext);
